export const ROUTE_HOME = '/'

// Root
export const ROUTE_SSP = '/sport-specific-preparation'
export const ROUTE_SSP_EXTRA_WORK = ROUTE_SSP + '/first-class-performance-extra-work'

export const ROUTE_FITNESS = '/fitness'
export const ROUTE_LANG_FITNESS = ROUTE_FITNESS

export const ROUTE_COURSES = '/kurse'
export const ROUTE_LANG_COURSES = ROUTE_COURSES

export const ROUTE_PRICING = '/preise'
export const ROUTE_LANG_PRICING = ROUTE_PRICING

export const ROUTE_TRIAL = '/kennenlerngespraech'

export const ROUTE_CONTACT = '/kontakt'
export const ROUTE_LANG_CONTACT = ROUTE_CONTACT

//Member
export const ROUTE_MEMBER = '/user/profile'

export const ROUTE_LOGIN = '/login'
export const ROUTE_LANG_LOGIN = ROUTE_LOGIN

export const ROUTE_REGISTER = '/register'
export const ROUTE_LANG_REGISTER = ROUTE_REGISTER

export const ROUTE_USER = '/user'

export const ROUTE_PROFILE = '/user/profile'

export const ROUTE_PACKAGE_TYPE_ARCHIV = '/user/archiv'
export const ROUTE_PACKAGE_TYPE_ARCHIV_EXTRAWORK = '/user/archiv/first-class-performance-extra-work'

export const ROUTE_SETTINGS = '/user/settings'
export const ROUTE_LANG_SETTINGS = ROUTE_SETTINGS

export const ROUTE_FORGOT_PASSWORD = '/forgotPassword'
export const ROUTE_LANG_FORGOT_PASSWORD = ROUTE_FORGOT_PASSWORD

export const ROUTE_SEND_VERIFICATION_EMAIL = '/user/sendVerificationMail'
export const ROUTE_LANG_SEND_VERIFICATION_EMAIL = ROUTE_SEND_VERIFICATION_EMAIL

// About
export const ROUTE_ABOUT = '/informationen'

// Root/About
export const ROUTE_STUDIO = ROUTE_ABOUT + '/studio'
export const ROUTE_LANG_STUDIO = ROUTE_STUDIO

export const ROUTE_TEAM = ROUTE_ABOUT + '/team'
export const ROUTE_LANG_TEAM = ROUTE_TEAM

export const ROUTE_VISION = ROUTE_ABOUT + '/erfahrung-und-vision'
export const ROUTE_LANG_VISION = ROUTE_VISION

// Legal
export const ROUTE_IMPRINT = '/impressum'
export const ROUTE_LANG_IMPRINT = ROUTE_IMPRINT
export const ROUTE_PRIVACY = '/datenschutz'
export const ROUTE_LANG_PRIVACY = ROUTE_PRIVACY
export const ROUTE_COOKIES = '/datenschutz#cookies'

// Blog Post
export const PATH_BLOG = '/blog'
export const ROUTE_BLOG = PATH_BLOG

// THIRD PARTY
export const ROUTE_DISCORD_INVITE = 'https://discord.gg/7bCfJAVr5h'
